import React from 'react';
import { useTheme } from './ThemeProvider';
import Surface from './Surface';
import { FooterProps } from 'tmwx-design-common';
import { styles } from '../utils/commonStyles';

const Footer: React.FC<FooterProps> = ({
    actionRight = null,
    actionCenter = null,
    actionLeft = null,
    rounded = true,
    shadow = false,
    style
}) => {
    const { padding } = useTheme();

    return (
        <Surface style={{
            ...styles.row,
            ...styles.justifyContent_spaceAround,
            ...{
                padding: padding,
            },
            ...style
        }}
            rounded={rounded}
            shadow={shadow}
        >
            {actionLeft && actionLeft}
            {actionCenter && actionCenter}
            {actionRight && actionRight}
        </Surface>
    )
};

export default Footer;